import { render, staticRenderFns } from "./reports-expiring-skills.vue?vue&type=template&id=3f49c77e"
import script from "./reports-expiring-skills.vue?vue&type=script&lang=js"
export * from "./reports-expiring-skills.vue?vue&type=script&lang=js"
import style0 from "./reports-expiring-skills.vue?vue&type=style&index=0&id=3f49c77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports